import { formatWindow } from '../format.js';
import { WINDOW_OPTIONS_HOURS } from '../config.js';
import { windowHours } from '../state/store.js';

type Props = {
  onSelect: (hours: number) => void;
};

export const WindowSelector = ({ onSelect }: Props) => (
  <label class="field">
    <span class="field__label">Ventana</span>
    <select
      class="field__select"
      value={String(windowHours.value)}
      onChange={event => onSelect(Number(event.currentTarget.value))}
    >
      {WINDOW_OPTIONS_HOURS.map(hours => (
        <option key={hours} value={String(hours)}>{formatWindow(hours)}</option>
      ))}
    </select>
  </label>
);
